<template>
  <section class="endorse-payment">
    <payment
      :orderId="orderId"
      :form="form"
      :is-fina="isFina"
      :policyModifyId="policyModifyId"
      type="endorsement"
    />
  </section>
</template>
<script>
import Payment from './payment'
export default {
  name: 'EndorsePayment',
  components: {
    Payment
  },
  props: {
    orderId: [String, Number],
    form: {
      type: Object,
      default: () => ({})
    },
    policyModifyId: {
      type: [String, Number],
      default: ''
    },
    isFina: {
      type:Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.endorse-payment {
    position: relative;
    padding: 15px;
}
</style>
